import _get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import {
  DashboardTaskCounterDocument,
  Task,
  TaskStatusEnum,
  useDashboardTaskShortQuery,
  useTaskBulkUpdateStatusMutation,
} from 'graphql-common';
import toast from '@lib/components/Toast/Toast';
import { showGraphQLErrors } from '@lib/utils/graphQLErrors';

type UseQueriesProps = {
  taskId?: string;
};

export default function useReporting(props: UseQueriesProps) {
  const { taskId = '' } = props;
  const { t } = useTranslation();

  const taskQuery = useDashboardTaskShortQuery({
    variables: { id: taskId, includeReportingSidebar: true },
    skip: !taskId,
    fetchPolicy: 'network-only',
  });
  const taskData = _get(taskQuery, 'data.data') as Task;
  const taskLoading = _get(taskQuery, 'loading');
  const taskError = _get(taskQuery, 'error');

  const [taskBulkUpdateStatusMutation] = useTaskBulkUpdateStatusMutation({
    // Keeps the sidebar "Approvals" item (DashboardLayout) in sync.
    refetchQueries: [DashboardTaskCounterDocument],
    onCompleted: () => {
      taskQuery.refetch();
      toast({ content: t('task-status-updated-successfully') });
    },
    onError: (error) => showGraphQLErrors(error, t),
  });

  const onStatusChangeHandler = (id: string, status: TaskStatusEnum) => {
    taskBulkUpdateStatusMutation({
      variables: { ids: [id], attributes: { status } },
    });
  };

  return {
    onStatusChangeHandler,
    refetchTask: taskQuery.refetch,
    taskData,
    taskError,
    taskLoading,
  };
}
